import type {
	v1GetOrganizationListResponse,
	v1Organization,
	v1WhiteLabelDetails,
} from '@clients/api/organization';

export interface IOrganizationStore extends v1GetOrganizationListResponse {
	current?: v1Organization | null;
	whiteLabel?: v1WhiteLabelDetails | null;
}

export interface IOrganization extends v1Organization {}

export enum OnboardFlow {
	ORGANIZATION_ONBOARD = 'organization_onboard',
	ORGANIZATION_MEMBER_ONBOARD = 'organization_member_onboard',
	PROJECT_MEMBER_ONBOARD = 'project_member_onboard',
	ORGANIZATION_ONBOARD_STEP2 = 'organization_onboard_step2',
	ORGANIZATION_ONBOARD_DONE = 'organization_onboard_done',
	ORGANIZATION_MEMBER_ONBOARD_DONE = 'organization_member_onboard_done',
	PROJECT_MEMBER_ONBOARD_DONE = 'project_member_onboard_done',
	INVITATION_EXPIRED = 'invitation_expired',
	ORGANIZATION_ONBOARD_ALREADY_DONE = 'organization_onboard_already_done',
	ORGANIZATION_MEMBER_ONBOARD_ALREADY_DONE = 'organization_member_onboard_already_done',
	PROJECT_MEMBER_ONBOARD_ALREADY_DONE = 'project_member_onboard_already_done',
}

export type {
	commonUpdateImageObject,
	v1AcceptOnboardInvitationResponse,
	v1AcceptOrgInvitationResponse,
	v1Organization,
} from '@clients/api/organization';
